
/** 
 * Definição de rotas principais e rotas filhas utilizando
 * o padrão Lazy Loading.
 * 
 * Uma vez que seja defino um path juntamente com 
 * um componente, as rotas definidas no componente serão
 * filhos do módulo pai, no caso, o AppRoutingModule.
 * 
 * Cada módulo carregado via Lazy Loading pode ter uma 
 * instância de RouterOutlet, onde poderão ser carregados
 * os módulos filhos.
 *   <router-outlet></router-outlet>
 * 
 *  
 * Para exemplificar, definiremos alguns módulos a serem
 * carregados aqui.
 * -------------------------------------------------------
 *  
 * {AuthModule} - (app/view/auth/auth.module.ts)
 *    / - <router-outlet></router-outlet>
 *      /login - (app/view/login/auth/login.module.ts)
 *      /recuperar-senha - (app/view/auth/recuperar-senha/recuperar-senha.module.ts)
 * 
 * HomeModule (app/view/home/home.module.ts)
 *    / - <router-outlet></router-outlet>
 *      /dashboard - (app/view/dashboard/dashboard.component.ts)
 *      /pagina1 - (app/view/pagina-1/pagina-1.module.ts)
 *      /pagina2 - (app/view/pagina-2/pagina-2.module.ts)
 * 
 * -------------------------------------------------------
 * 
 * Referências:
 * {@link https://angular.io/guide/lazy-loading-ngmodules | Lazy Loading}
 * {@link https://angular.io/api/router/RouterOutlet | RouterOutlet}
 * 
*/

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modules } from './core/application/features/modules';
import { AuthGuard } from './guards/auth.guard';
import { ModuleService } from './services/module.service';
import { SharedModule } from './shared/shared.module';
import { NavbarModule } from './view/navbar/navbar.module';
import { NotFoundComponent } from './view/not-found/not-found.component';
import { SidenavComponent } from './view/sidenav/sidenav.component';

const routes: Routes = [
    { path: '', redirectTo: 'atendimento', pathMatch: 'full' },
    { path: '', loadChildren: './view/auth/auth.module#AuthModule' },
    { 
        path: '', 
        loadChildren: () => import('./view/auth/auth.module').then(m => m.AuthModule)
    },
    { path: 'atendimento', component: SidenavComponent, canActivate: [AuthGuard], loadChildren: './view/atendimento/atendimento.module#AtendimentoModule' },
    { path: 'operacao', component: SidenavComponent, canActivate: [AuthGuard], loadChildren: './view/operacao/operacao.module#OperacaoModule' },
    { path: 'administrativo', component: SidenavComponent, canActivate: [AuthGuard], loadChildren: './view/administrativo/administrativo.module#AdministrativoModule' },
    { path: 'gratuidade', component: SidenavComponent, canActivate: [AuthGuard], loadChildren: './view/gratuidade/gratuidade.module#GratuidadeModule' },
    //{ path: '**', redirectTo: '404' },
    { path: '404', component: NotFoundComponent },
    { path: 'parametros', component: SidenavComponent, canActivate: [AuthGuard], loadChildren: './view/parametro/parametro-form/parametro-form.module#ParametroFormModule' },
];
@NgModule({
    declarations: [
        SidenavComponent
    ],
    imports: [
        RouterModule.forRoot(routes, {useHash: true, onSameUrlNavigation: 'reload'}),
        SharedModule,
        NavbarModule
    ],
    providers: [
        AuthGuard,
        ModuleService,
        Modules
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
